import { useLang } from '../i18n';

export function PromoBar() {
  const { t } = useLang();
  return (
    <div
      data-testid="promo-bar"
      className="fixed inset-x-0 top-0 z-50 flex h-12 items-center justify-center bg-[#E10600] px-6 sm:h-10"
    >
      <p className="text-center font-mono text-[9px] font-medium uppercase leading-[1.6] tracking-[0.18em] text-white sm:whitespace-nowrap sm:text-xs sm:tracking-[0.24em]">
        {t('promo.bar')}
      </p>
    </div>
  );
}
